import { Box, EmptyState } from '@dixa/lib-shared-habla';

export const AnalyticsFilterLayoutEmpty = (): JSX.Element => (
  <Box as="li" padding="250 300">
    <EmptyState
      title="No items found"
      description="Try changing your search criteria."
    />
  </Box>
);
